import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './layout-web/main-layout/main-layout.component';
import { AdminLayoutComponent } from './layout-admin/admin-layout/admin-layout.component';
import { LoginPageComponent } from './admin/login-page/login-page.component';
import { AuthenticationGuard } from './auth/authentication.guard';
import { ForgetPasswordComponent } from './admin/forget-password/forget-password.component';
import { ChangePasswordComponent } from './admin/change-password/change-password.component';
import { PageNotFoundComponent } from './web/page-not-found/page-not-found.component';

const routes: Routes = [

  { path: 'wgiacm', component: LoginPageComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  {
    path: '',
    component: MainLayoutComponent,
  
    children: [
      
      { path: '',  loadChildren: () => import('./web/web.module').then(m => m.WebModule) },
      {path: '404', component: PageNotFoundComponent},
      
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthenticationGuard],
    children: [
      
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/parking-fee/parking-fee.module').then(m => m.ParkingFeeModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/reservations/reservations.module').then(m => m.ReservationsModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/report/report-routing.module').then(m => m.ReportRoutingModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/module/module.module').then(m => m.ModuleModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/user/user.module').then(m => m.UserModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/role/role.module').then(m => m.RoleModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/menu/menu.module').then(m => m.MenuModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/property/property.module').then(m => m.PropertyModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/permission/permission.module').then(m => m.PermissionModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/revenue/revenue.module').then(m => m.RevenueModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/profile-setting/profile-setting.module').then(m => m.ProfileSettingModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/package/package.module').then(m => m.PackageModule) },
      { path: '',  canActivateChild: [AuthenticationGuard], loadChildren: () => import('./admin/promotion/promotion.module').then(m => m.PromotionModule) },

      
      
    ]
  },
  
      {path: '**', redirectTo: '/404'}
      
      
  


  
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
